// 111 §5c — the Link icon a row shows when its item HAS links, in the link
// colour (`--hll`, §5d's token — never a literal). HIDDEN otherwise: an empty
// link icon on every row is noise (the brief's default, not ruled otherwise).
// Click = the cluster highlight (src/lib/linkHighlight.ts); the row's own
// click never fires (stopPropagation — rows navigate).
import { Link } from "lucide-react";
import { useTranslation } from "../i18n";
import {
  connectedComponentOf,
  highlightLinkCluster,
  type LinkRef,
} from "../lib/linkHighlight";

export default function LinkIcon({
  matterRow,
  item,
  scroll = true,
  size = 11,
}: {
  /** The matter row holding itemLinks; absent (e.g. a surface with no matter
   *  feed, like the compact column) renders nothing. */
  matterRow?: { itemLinks?: unknown } | null;
  item: LinkRef;
  /** Eisenhower passes false: highlight in place, no scroll assist (v-f). */
  scroll?: boolean;
  size?: number;
}) {
  const { t } = useTranslation();
  /* 112 §3 — the WHOLE connected component (the closure walk), not the direct
     partners: clicking any member lights the entire chain. Presence semantics
     are identical (an unlinked item's component-minus-self is empty). */
  const others = connectedComponentOf(matterRow, item);
  if (!others.length) return null;
  return (
    <button
      type="button"
      style={{
        background: "none",
        border: "none",
        padding: "0 2px",
        color: "var(--hll)",
        cursor: "pointer",
        display: "inline-flex",
        alignItems: "center",
        flexShrink: 0,
        lineHeight: 0,
      }}
      title={t("links.icon_tip", { fallback: "Show linked items" })}
      onClick={(e) => {
        e.stopPropagation();
        highlightLinkCluster(item, others, { scroll });
      }}
    >
      <Link size={size} />
    </button>
  );
}
